import id from '../JsonLang/id.json'
export const lang = { ...id }